import { LoadStylesheet } from '../spencer-components/Utilities'
import styles from './bootstrap-style.scss?inline';

const stylesheet = LoadStylesheet({
    body: styles,
    global: true
});


//const styleSheet = new CSSStyleSheet();
//styleSheet.replaceSync( styles.toString() );
//
//if( !document.adoptedStyleSheets ) {
//    document.adoptedStyleSheets = [];
//}
//document.adoptedStyleSheets.push( styleSheet );
(document as any).bootstrapLoaded = true;

export default stylesheet;